module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-2.ac2c2268.jpg";